import type { MaybeRefOrGetter } from 'vue';
import type { LicenseEntitlementBooleanKey } from '#layers/license/types/license';
import { computed, toValue } from 'vue';
import { useSystemLicenseStore } from '#layers/license/stores/license';

/**
 * Reactive view of a boolean license gate.
 *
 * `isGated` is true only once the license has loaded AND the entitlement is absent. It stays false
 * while the license is loading (or failed to load), so the server remains the source of truth and
 * the UI fails open — mirroring how the numeric guard leaves `!isLoaded` unblocked.
 */
export function useLicenseEntitlementGate(key: MaybeRefOrGetter<LicenseEntitlementBooleanKey>) {
	const license = useSystemLicenseStore();

	const isGated = computed(() => license.isLoaded && !license.hasEntitlement(toValue(key)));

	return { isGated };
}
